import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import DenStore from 'src/stores/DenStore';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Grid, Drawer, AppBar, Toolbar, IconButton, FormControl, InputLabel, Table, Select, MenuItem, TableHead, TableRow, TableCell, TableBody, Typography, TextField, Paper, List, ListItem, ListItemText, ListItemIcon, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, InputAdornment, Tabs, Tab, Checkbox, Switch } from '@material-ui/core';
import Klient from 'src/models/Klient';
import { computed, observable, action } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import { inject, observer } from 'mobx-react';
import 'src/assets/styles/index.css'
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import 'moment/locale/cs';
import {ClientDaysSection} from 'src/components/ClientDaysSection';
import {ClientTurnusesSection} from 'src/components/ClientTurnusesSection';
import HistoryListing from './HistoryListing';
import HistorieStore from 'src/stores/HistorieStore';
import FakturaceStore from 'src/stores/FakturaceStore';
import AddIcon from '@material-ui/icons/Add';
import FakturacniSubjekt from 'src/models/FakturacniSubjekt';
import SearchIcon from '@material-ui/icons/Search';
import { isNullOrUndefined } from 'util';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import NovaObjednavka from "../models/NovaObjednavka";
import ObjednavkaStore from "../stores/ObjednavkaStore";

export interface IClientDetailProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    objednavkaStore?: ObjednavkaStore;
    turnusStore?: TurnusStore;
    historieStore?: HistorieStore;
    denStore?: DenStore;
    fakturaceStore?: FakturaceStore;
    ciselnikyStore?: CiselnikyStore;
    klientId: number;
}

@inject('klientStore')
@inject('objednavkaStore')
@inject('turnusStore')
@inject('denStore')
@inject('historieStore')
@inject('fakturaceStore')
@inject('ciselnikyStore')
@observer
class ClientDetail extends React.Component<IClientDetailProps>{

    constructor(props: Readonly<IClientDetailProps>) {
        super(props);
        console.log("LOAD: ClientDetail/" + props.klientId);
    }

    // Dialogs
    
    @observable private isDeleteDialogOpened: boolean = false;
    @observable private isHistoryDialogOpen: boolean = false;
    @observable private isAddSubjectDialogOpen: boolean = false;
    
    // Tabs
    @observable private activeTab: number = 0;

    @action
    private onCloseDeleteDialog = event => {
        this.isDeleteDialogOpened = !this.isDeleteDialogOpened;
    }

    private handleDeleteDialogOK = event => {
        if(this.toDelete === 'client') {
            this.props.klientStore.deleteClient(this.clientBacking)
                .then(resp => {
                    this.props.history.push(`/clients`);
                });
        } else if (this.toDelete === 'subject') {
            this.props.fakturaceStore.removeExistingSubject(this.subjektToDelete);
            this.isDeleteDialogOpened = false;
        }
    }

    // Other stuff
    @observable private isDrawerOpened: boolean = false;
    @observable private dirty: boolean = false;
    @observable private filterText: string = "";

    // Delete
    private toDelete: string = '';
    private subjektToDelete: FakturacniSubjekt = null;

    private clientBacking: Klient = null;
    @computed private get client(): Klient {
        if (!this.clientBacking || (this.clientBacking.id !== this.props.klientId)) {
            this.clientOriginal = this.props.klientStore.getClientById(this.props.klientId);
            if(this.clientOriginal) {
                this.clientBacking = this.clientOriginal.clone();
            }
        }

        return this.clientBacking;
    }

    @computed private get filteredItems(): FakturacniSubjekt[] {
        return this.props.fakturaceStore.availableSubjects.filter((subjekt: FakturacniSubjekt) => {
            if(subjekt.name.includes(this.filterText)) {
                return true;
            }
            return false;
        }).slice(0, 4);
    }

    private clientOriginal: Klient = null;

    @action
    private handleChange = name => event => {
        this.dirty = true;
        this.client[name] = event.target.value;
    };

    @action
    private handleCheckedChange = (name, checked, unchecked) => event => {
        this.dirty = true;
        this.client[name] = event.target.checked ? checked : unchecked;
    };

    @action
    private handleTabChange = (event, value) => {
        this.activeTab = value;
    };

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private handleDoneClick = event => {
        if(this.dirty) {
            this.props.klientStore.updateClient(this.clientBacking)
                .then(resp => {
                    this.clientOriginal.loadFromEntity(this.clientBacking);
                    this.dirty = false;
                });
        }
    }

    private handleClientDeleteClick = event => {
        this.toDelete = 'client';
        this.isDeleteDialogOpened = true;
    }

    private handleSubjectDeleteClick = (subjekt: FakturacniSubjekt) => event => {
        this.toDelete = 'subject';
        this.subjektToDelete = subjekt;
        this.isDeleteDialogOpened = true;
    }

    private onCloseHistoryDialog = event => {
        this.isHistoryDialogOpen = false;
    }

    private onCloseAddSubjectDialog = event => {
        this.isAddSubjectDialogOpen = false;
    }

    private showHistory = event => {
        this.props.historieStore.loadClientHistory(this.props.klientId).then(success => {
            this.isHistoryDialogOpen = true;
        });
    }

    private placeOrder = event => {
        const newObj = new NovaObjednavka();
        newObj.addNewClient(this.client);
        this.props.objednavkaStore.orderTemplate = newObj;
        this.props.history.push(`/neworder`);
    }

    @action
    private handleAddSubject = event => {
        this.isAddSubjectDialogOpen = true;
    }

    private addSubjectOnSelect = subjekt => event => {
        const newSubjekt = subjekt.clone();
        newSubjekt.idKlient = this.props.klientId;
        newSubjekt.relationType = 'external';
        this.props.fakturaceStore.addNewSubjekt(newSubjekt).then(sbj => {
            this.isAddSubjectDialogOpen = false;
        })        
    }

    public render() {
        return (
            this.client ?
                <div>
                    <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                        <NavigationDrawerItems />
                    </Drawer>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                        Karta klienta - {this.client.jmeno + ' ' + this.client.prijmeni}
                                    </Typography>
                                    <IconButton color="inherit" aria-label="Delete" onClick={this.handleClientDeleteClick}>
                                        <DeleteIcon />
                                    </IconButton>
                                    <Button onClick={this.placeOrder} color="inherit">
                                        Nová objednávka
                                    </Button>
                                    <Button onClick={this.showHistory} color="inherit">
                                        Historie
                                    </Button>
                                </Toolbar>
                            </AppBar>
                        </Grid>

                        <Grid item xs={12} style={{ margin: 8 }}>
                            <Paper square>
                                <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                    <Tabs 
                                        value={this.activeTab} 
                                        onChange={this.handleTabChange}
                                        indicatorColor="primary">
                                        <Tab label="Základní údaje" />
                                        <Tab label="Rozvoz" />
                                        <Tab label="Turnusy &amp; Dny" />
                                        <Tab label="Fakturace &amp; Objednavky" />

                                        <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }} />

                                        {(this.activeTab === 0 || this.activeTab === 1) && 
                                            <IconButton color="inherit" aria-label="Done" onClick={this.handleDoneClick}>
                                                { !this.dirty ? <DoneIcon /> : <SaveIcon /> }
                                            </IconButton>}
                                        {this.activeTab === 3 && 
                                            <IconButton color="inherit" aria-label="Done" onClick={this.handleAddSubject}>
                                                <AddIcon />
                                            </IconButton>}
                                    </Tabs>
                                </AppBar>
                                {this.activeTab === 0 && 
                                <Grid item xs={12} style={{ margin: 8 }}>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-name`} label="Jméno" value={this.client.jmeno} fullWidth
                                                onChange={this.handleChange('jmeno')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-lastName`} label="Příjmení" value={this.client.prijmeni} fullWidth
                                                onChange={this.handleChange('prijmeni')} />
                                        </Grid>
                                    </Grid>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-tel`} label="Telefon" value={this.client.telefon} fullWidth
                                                onChange={this.handleChange('telefon')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-mail`} label="e-mail" value={this.client.email} fullWidth
                                                onChange={this.handleChange('email')} />
                                        </Grid>
                                    </Grid>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-street`} label="Ulice/Čp" value={this.client.ulice} fullWidth
                                                onChange={this.handleChange('ulice')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-city`} label="Město" value={this.client.mesto} fullWidth
                                                onChange={this.handleChange('mesto')} />
                                        </Grid>
                                    </Grid>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={6}>
                                            <TextField id={`${this.client.id}-street`} label="PSČ" value={this.client.PSC} fullWidth
                                                onChange={this.handleChange('PSC')} />
                                        </Grid>
                                    </Grid>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={12}>
                                            <TextField id={`${this.client.id}-note`} label="Poznámka" value={this.client.poznamka} fullWidth multiline
                                                onChange={this.handleChange('poznamka')} />
                                        </Grid>
                                    </Grid>
                                </Grid>}
                                {this.activeTab === 1 &&
                                <Grid item xs={12} style={{ margin: 8 }}>
                                    <Grid container className="default-margin" spacing={8}>
                                        <Grid item xs={12}>
                                            <TextField label="Trasa" id="klient-trasa" select onChange={this.handleChange('trasa')} 
                                                value={this.client.trasa}>
                                                    <MenuItem value="">Vyberte trasu</MenuItem>
                                                    {this.props.ciselnikyStore.trasy.map(trasa => (
                                                        <MenuItem value={trasa.id}>{trasa.name}</MenuItem>
                                                    ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12}>
                                            Střídavý rozvoz: <Switch checked={this.client.stridavyRozvoz === 'resit'} onChange={this.handleCheckedChange('stridavyRozvoz', 'resit', 'neresit')} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id={`${this.client.id}-secondaryAddress`} label="Náhradní adresa" value={this.client.nahradniAdresa} fullWidth multiline
                                                onChange={this.handleChange('nahradniAdresa')} />
                                        </Grid>
                                    </Grid>
                                </Grid>}
                                {this.activeTab === 2 && 
                                    <Grid item xs={12} style={{ margin: 8 }}>
                                        <Grid container spacing={8} style={{ marginBottom: 8 }}>
                                            <Grid item xs={6}>
                                                <ClientTurnusesSection klientId={this.client.id} />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <ClientDaysSection klientId={this.client.id} />
                                            </Grid>
                                        </Grid>
                                    </Grid>}
                                {this.activeTab === 3 && 
                                    <Grid container spacing={8} style={{ marginTop: 10 }}>
                                        <Grid item xs={6} spacing={8} style={{ marginTop: 10, paddingLeft: 10, paddingRight: 10 }}>
                                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                Subjekty
                                            </Typography>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Jmeno</TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                </TableHead>
                                                {isNullOrUndefined(this.props.fakturaceStore.subjectsByKlientID.get(this.props.klientId)) ?
                                                <TableBody>
                                                    <TableRow hover>
                                                            <TableCell colSpan={3}>Zadne subjekty</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                                :
                                                <TableBody>
                                                    {this.props.fakturaceStore.subjectsByKlientID.get(this.props.klientId).map(subjekt => (
                                                        <TableRow hover key={subjekt.id}>
                                                            <TableCell>{subjekt.name}</TableCell>
                                                            <TableCell>
                                                                {subjekt.relationType === 'external' ?
                                                                <IconButton color="inherit" aria-label="Delete" onClick={this.handleSubjectDeleteClick(subjekt)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                                : <IconButton disabled color="inherit" aria-label="Delete" onClick={this.handleSubjectDeleteClick(subjekt)}>
                                                                    <DeleteIcon />
                                                                </IconButton>}
                                                            </TableCell>
                                                        </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                                }
                                            </Table>
                                        </Grid>
                                    </Grid>}
                            </Paper>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.isDeleteDialogOpened}
                        onClose={this.onCloseDeleteDialog}
                        aria-labelledby="delete-confirm-dialog">
                        <DialogTitle id="delete-confirm-dialog">Smazat</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Opravdu smazat?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseDeleteDialog} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleDeleteDialogOK} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.isHistoryDialogOpen}
                        onClose={this.onCloseHistoryDialog}
                        aria-labelledby="history-dialog"
                        maxWidth="md"
                        fullWidth>
                        <DialogTitle id="history-dialog">Historie</DialogTitle>
                        <DialogContent>
                            <HistoryListing />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseHistoryDialog} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.isAddSubjectDialogOpen}
                        onClose={this.onCloseAddSubjectDialog}
                        aria-labelledby="add-client-dialog">
                        <DialogTitle id="add-client-dialog">Pridat klienta</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={8}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        label="Hledejte"
                                        value={this.filterText}
                                        onChange={this.handleChange('filterText')}
                                        InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <List>
                                        {this.filteredItems.map(it => (
                                            <ListItem onClick={this.addSubjectOnSelect(it)} button>
                                                <ListItemText primary={it.name} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseAddSubjectDialog} color="primary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                : <Typography variant="h5">Nenalezen</Typography>
        )
    }
}

export default withRouter(ClientDetail)



// WEBPACK FOOTER //
// ./src/components/ClientDetail.tsx